import React from 'react';
import { Route, Switch } from 'react-router-dom';

import PrivateRoute from '../PrivateRoute';
import Home from '../Home';
import Footer from '../Footer';
import About from '../About';
import FAQ from '../FAQ';
import SignUp from '../SignUp';
import Login from '../Login';
import ForgotPassword from '../ResetPassword/ForgotPassword';
import ResetPassword from '../ResetPassword';
import Logout from '../Logout';
import Portfolio from '../Portfolio';
import RedirectToFirstAccount from '../Portfolio/RedirectToFirstAccount';
import OfferingList from '../OfferingList';
import Offering from '../Offering';
import SecurityDetail from '../SecurityDetail';
import NonTradedDetail from '../NonTradedDetail';
import NonTradedInfo from '../NonTradedDetail/NonTradedInfo';
import History from '../History/index';
import RouteNotFound from './RouteNotFound';
import Invest from '../Invest';
import ExternalInvest from '../ExternalInvest';
import ManageAccount from '../ManageAccount/index';
import TransferFunds from '../TransferFunds';
import TransferInstructions from '../TransferFunds/TransferInstructions';
import VerifyEmailAddress from '../VerifyEmailAddress';
import CustomerAgreements from '../SignUp/CustomerAgreements';
import ArbitrationClauses from '../SignUp/ArbitrationClauses';
import AccountDocs from '../AccountDocs';
import SecurityTrade from '../SecurityTrade';
import AccountChangePassword from '../AccountChangePassword';
import UploadVerifyDocs from '../UploadVerifyDocs';
import { withAutoScroll } from './AutoScroll';
import ComingSoonOtherFactors from '../ComingSoonOfferDisclaimer/OtherFactors';
import OtherFactors from '../OtherFactors';
import RemoveOfferWatch from '../OfferWatches/RemoveOfferWatch';
import CaptureQueryString from '../CaptureQueryString';
import Alerts from '../Alerts';
import { allPages, createSimplePageComponent } from '../SimplePages';
import { withErrorBoundary } from '../ErrorPage/ErrorBoundary';

import './index.css';
import UploadDriverLicense from '../UploadDriverLicense';
import Suitability from '../Suitability';


export default () => (
  <div styleName="App">
    <CaptureQueryString />
    <Alerts />
    <div styleName="AppContent">
      <Switch>
        <Route
          path="/sign-up"
          component={withErrorBoundary(withAutoScroll(SignUp), 'Sign Up Error')}
        />
        <Route
          path="/login"
          component={withErrorBoundary(withAutoScroll(Login), 'Login Error')}
        />
        <Route
          path="/forgot-pass"
          component={withErrorBoundary(withAutoScroll(ForgotPassword), 'Forgot Password Error')}
        />
        <Route
          path="/reset-pass/:token"
          component={withErrorBoundary(withAutoScroll(ResetPassword), 'Reset Password Error')}
        />
        <Route path="/logout" component={Logout} />
        <PrivateRoute exact path="/portfolio" component={RedirectToFirstAccount} />
        <PrivateRoute
          path="/portfolio/:accountNumber"
          component={withErrorBoundary(withAutoScroll(Portfolio), 'Summary Error')}
        />
        <PrivateRoute
          path="/history"
          component={withErrorBoundary(withAutoScroll(History), 'History Error')}
        />
        <Route
          exact
          path="/offers"
          component={withErrorBoundary(withAutoScroll(OfferingList), 'Offers Error')}
        />
        <Route
          path="/offers/:offerId"
          component={withErrorBoundary(withAutoScroll(Offering), 'Offer Error')}
        />
        <PrivateRoute
          path="/securities/:securityId"
          component={withErrorBoundary(withAutoScroll(SecurityDetail), 'Security Error')}
        />
        <PrivateRoute
          path="/priv-securities/:securityId"
          component={withErrorBoundary(withAutoScroll(NonTradedDetail), 'Security Error')}
        />
        <PrivateRoute
          path="/invest/:offerId"
          component={withErrorBoundary(withAutoScroll(Invest), 'Invest Error')}
        />
        <PrivateRoute
          path="/external-invest/:offerId"
          component={withErrorBoundary(withAutoScroll(ExternalInvest), 'Invest Error')}
        />
        <PrivateRoute
          path="/account/:accountNumber/docs"
          component={withErrorBoundary(withAutoScroll(AccountDocs), 'Statements and Documents Error')}
        />
        <PrivateRoute
          exact
          path="/account/:accountNumber/password"
          component={withAutoScroll(withErrorBoundary(AccountChangePassword), 'Change Password Error')}
        />
        <PrivateRoute
          path="/account/:accountNumber"
          component={withErrorBoundary(withAutoScroll(ManageAccount), 'Manage Account Error')}
        />
        <PrivateRoute
          path="/account/"
          component={withErrorBoundary(withAutoScroll(ManageAccount), 'Manage Account Error')}
        />
        <PrivateRoute
          path="/transfers/:accountNumber"
          component={withErrorBoundary(withAutoScroll(TransferFunds), 'Transfer Funds Error')}
        />
        <PrivateRoute
          path="/transfer-instructions/:type"
          component={withErrorBoundary(withAutoScroll(TransferInstructions), 'Transfer Instructions Error')}
        />

        <PrivateRoute path="/non-traded-info/:securityId?" component={withAutoScroll(NonTradedInfo)} />

        <Route path="/about" component={withAutoScroll(About)} />
        <Route
          path="/faq"
          component={withErrorBoundary(FAQ, 'FAQ Error')}
        />
        <PrivateRoute
          path="/security-trade/:securityId/:tradeDir"
          component={withErrorBoundary(withAutoScroll(SecurityTrade), 'Trade Security Error')}
        />
        <Route
          path="/verify-email/:token"
          component={withErrorBoundary(withAutoScroll(VerifyEmailAddress), 'Verify Email Error')}
        />
        <Route path="/customer-agreements" component={withAutoScroll(CustomerAgreements)} />
        <Route
          exact
          path="/"
          component={withErrorBoundary(withAutoScroll(Home), 'Home Error')}
        />
        <Route path="/arbitration-clauses" component={withAutoScroll(ArbitrationClauses)} />

        <PrivateRoute
          path="/user/:userId/upload-document"
          component={withErrorBoundary(withAutoScroll(UploadVerifyDocs), 'Document Upload Error')}
        />
        <PrivateRoute
          path="/user/:userId/upload-dl"
          component={withErrorBoundary(withAutoScroll(UploadDriverLicense), 'Document Upload Error')}
        />
        <Route path="/coming-soon-other-factors" component={withAutoScroll(ComingSoonOtherFactors)} />
        <Route path="/other-factors" component={withAutoScroll(OtherFactors)} />
        <Route path="/offer-watches/:offerWatchId/remove" component={withAutoScroll(RemoveOfferWatch)} />
        <Route path="/suitability" component={withAutoScroll(Suitability)} />
        {allPages.map(page => (
          <Route
            exact
            key={page.path}
            path={page.path}
            component={withErrorBoundary(withAutoScroll(createSimplePageComponent(page)), 'My IPO Encountered an Error')}
          />
        ))}

        <Route component={withAutoScroll(RouteNotFound)} />
      </Switch>
    </div>
    <Footer />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/App/index.js